import withSaleSummary from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/withSaleSummary'
import SaleSummaryView from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/SaleSummary'

const SaleSummary = withSaleSummary(SaleSummaryView)

export default SaleSummary
